import { NavLink } from 'react-router-dom'
import './TabNavigation.css'

export default function TabNavigation() {
  return (
    <div className="tab-navigation">
      <NavLink className="tab" to="/wallet">
        Wallet
      </NavLink>
      <NavLink className="tab" to="/account">
        Account
      </NavLink>
      <NavLink className="tab" to="/orders">
        Orders
      </NavLink>
    </div>
  )
}
